import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

export function Calendar({ fecha = null, setFecha, label, sx = {} }) {
  return (
    <DatePicker
      sx={sx}
      label={label}
      value={fecha ? dayjs(fecha) : null}
      onChange={(newValue) => {
        //Pasar valor en formato YYYY-MM-DD
        if (newValue) {
          setFecha({
            fecha: dayjs(newValue).format("YYYY-MM-DD"),
          });
        } else {
          setFecha({
            fecha: "",
          });
        }
      }}
      style={{
        marginBottom: 50,
      }}
    />
  );
}
